import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let arrowColor = '#C1C1C1'
let arrowColorHighlighted = '#717171'

export function setSortation (column, columnChild, columnSortStatus, sortListVuex) {
  var icon = document.getElementById(column)
  var arrowUp = icon && icon.querySelector('.icon-sort-arrow-up')
  var arrowDown = icon && icon.querySelector('.icon-sort-arrow-down')

  let listParameters = {
    'sort': columnSortStatus[column],
    'column': column,
    'columnChild': columnChild || null
  }
  if (listParameters.sort === 'asc') {
    // Sort
    sortListVuex(listParameters)
    // Highlight
    resetSortSvgStatus()
    if (arrowUp) arrowUp.style.fill = arrowColor
    if (arrowDown) arrowDown.style.fill = arrowColorHighlighted
    findAndReplace(columnSortStatus, 'desc', 'asc')
    columnSortStatus[column] = 'desc'
  } else {
    // Sort
    sortListVuex(listParameters)
    // Hightlight
    resetSortSvgStatus()
    if (arrowUp) arrowUp.style.fill = arrowColorHighlighted
    if (arrowDown) arrowDown.style.fill = arrowColor
    findAndReplace(columnSortStatus, 'desc', 'asc')
    columnSortStatus[column] = 'asc'
  }
  return columnSortStatus[column]
}

export function resetSortSvgStatus () {
  var classListSvg = document.getElementsByClassName('icon-sort-arrow')
  for (var i = 0; i < classListSvg.length; ++i) {
    var item = classListSvg[i]
    item.style.fill = arrowColorHighlighted
  }
}

export function findAndReplace (object, value, replacevalue) {
  for (var x in object) {
    if (object.hasOwnProperty(x)) {
      if (typeof object[x] === 'object') {
        findAndReplace(object[x], value, replacevalue)
      }
      if (object[x] === value) {
        object[x] = replacevalue
      }
    }
  }
}

export function sortColumn (column, child, typeOrdenation) {
  switch (typeOrdenation) {
    case 'length':
      return function (a, b) {
        if (!a[column]) {
          return -1
        }

        if (!b[column]) {
          return +1
        }
        return a[column].length - b[column].length
      }
    case 'one-field-level':
      return function (a, b) {
        if (!a[column]) {
          return -1
        }

        if (!b[column]) {
          return +1
        }
        return a[column].toString().localeCompare(b[column].toString(), undefined, { numeric: true, sensitivity: 'base' })
      }
    case 'two-field-level':
      return function (a, b) {
        if (!a[column]) {
          return -1
        }

        if (!b[column]) {
          return +1
        }
        return a[column][child].toString().localeCompare(b[column][child].toString(), undefined, { numeric: true, sensitivity: 'base' })
      }
  }
}
